import React from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {MakeUfSelection} from 'main/factories/pages';

const {title} = translations['pt-br'].privateFlow.requestAuthorizations.initialFlow;

export function RequestStates() {
	return (
		<PageWrapperLayout title={title}>
			<MakeUfSelection flowType={FlowEnum.AUTHORIZATIONS} />
		</PageWrapperLayout>
	);
}
